import { getToken, storeToken } from "../utils/utilFunctions";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

/**
 * Sends login request to backend.
 * @param {string} email 
 * @param {string} password 
 * @returns {Promise<{ token: string, user: object }>}
 */
export async function loginUser(email, password) {
    const response = await fetch(`${API_URL}/api/users/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
        throw new Error(data.message || "login_failed");
    }

    const token = response.headers.get('X-Auth-Token');
    storeToken(token);

    return data.data;
}

export async function fetchCompanyEmployees(setEmployees) {
    const token = getToken();
    const response = await fetch(`${API_URL}/api/users/employees`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
        throw new Error(data.message || "fetch_employees_failed");
    }
    setEmployees(data.data);
    return data.data;
}

/**
 * Sends registration request to backend.
 * @param {string} name
 * @param {string} email 
 * @param {string} password 
 * @returns {Promise<{ token: string, user: object }>}
 */
export async function registerUser(name, email, password) {
    try {
        const response = await fetch(`${API_URL}/api/users/register`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ name, email, password }),
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
            throw new Error(data.message || "registration_failed");
        }

        const token = response.headers.get('X-Auth-Token');
        console.log('token: ', token);
        storeToken(token);

        return data.data;
    } catch (error) {
        // Pass a clean error with just the message for UI handling
        throw new Error(error.message || "registration_failed");
    }
}

export const apiCheckLogin = async (errorCallBack, setUser) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const token = getToken();
    try {
        const response = await fetch(`${apiUrl}/api/users/checkLogin`, {
            method: 'GET', // or 'GET' depending on your APIS
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });

        const data = await response.json();
        if (!data.success) {
            errorCallBack()
        } else {
            setUser(data.data)
        }
    } catch (error) {
        console.error('Error:', error);
        errorCallBack()
    }
}

export async function getEmployeeById(id) {
    const token = getToken();
    const response = await fetch(`${API_URL}/api/users/employees/${id}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
        throw new Error(data.message || "fetch_employee_failed");
    }

    return data.data;
}

export async function createEmployee(payload) {
    const token = getToken();
    const response = await fetch(`${API_URL}/api/users/employees`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
        throw new Error(data.message || "create_employee_failed");
    }

    return data.data;
}

export async function updateEmployee(id, payload) {
    const token = getToken();
    const response = await fetch(`${API_URL}/api/users/employees/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
        throw new Error(data.message || "update_employee_failed");
    }

    return data.data;
}

export async function deleteEmployee(id) {
    const token = getToken();
    const response = await fetch(`${API_URL}/api/users/employees/${id}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
        throw new Error(data.message || "delete_employee_failed");
    }

    return data.data;
}

export async function resetPassword(token, newPassword) {
    const response = await fetch(`${API_URL}/api/users/reset-password`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ token, newPassword }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
        throw new Error(data.message || "password_reset_failed");
    }

    return data.data;
}

export async function resetPasswordRequest(email) {
    const response = await fetch(`${API_URL}/api/users/reset-password-request`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
        throw new Error(data.message || "password_reset_request_failed");
    }

    return data;
}